import React from "react";
import CrudPage from "@/components/common/CrudPage";
import { Smartphone } from "lucide-react";

const FIELDS = [
  { k: "category", label: "Κατηγορία (email/μήνυμα/screenshot/κάμερα/άλλο)" },
  { k: "title", label: "Τίτλος" },
  { k: "timestamp", label: "Χρονοσήμανση", type: "datetime-local" },
  { k: "metadata", label: "Μεταδεδομένα", type: "textarea", rows: 3 },
  { k: "chain_of_custody", label: "Αλυσίδα φύλαξης", type: "textarea", rows: 2 },
  { k: "inconsistencies", label: "Ασυνέπειες / Ζητήματα", type: "textarea", rows: 2 },
  { k: "notes", label: "Σημειώσεις", type: "textarea", rows: 2 },
];

export default function DigitalEvidence() {
  return (
    <CrudPage
      slug="digital-evidence" title="Ψηφιακά Αποδεικτικά"
      subtitle="Emails, μηνύματα, screenshots, μεταδεδομένα, χρονοσημάνσεις και ασυνέπειες."
      emptyIcon={Smartphone} fields={FIELDS}
      listColumns={{
        title: it => it.title,
        subtitle: it => it.category,
        body: it => it.metadata,
      }}
      badges={{}}
    />
  );
}
